import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from './PageHeader';

const PageCard = ({ route, children }) => (
  <div className="bg-white p-4 pt-12 md:p-6 md:pt-12 border border-blue-200/60 shadow-sm rounded-2xl mb-8 relative">
    <PageHeader route={route} />
    {children}
  </div>
);

PageCard.propTypes = {
  route: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default PageCard;
